import { useQuery } from '@tanstack/react-query';
import { ROUTES, type Agent, type Rfq } from '@serb/shared';
import { api } from '../../api/client';
import { useVaultRecords } from '../claudeTasks/useVaultRecords';

/** The overseas agents, read from the Serb Mind vault */
export const useAgents = () => useVaultRecords<Agent>('agents', 'Agent', () => api.get(ROUTES.api.agents));

/** Every request for rates and what came back, from the vault's agent quotes (Data/quotes.csv) */
export const useRfqs = () => {
  const q = useQuery({ queryKey: ['rfqs'], queryFn: () => api.get<Rfq[]>(ROUTES.api.rfqs) });
  return q.data ?? [];
};
